import { createContext, useEffect, useMemo, useState } from "react";
import { getInvitesInRealTime } from "../Config/db/invite.retrieve";

export const InviteContext = createContext();

export const InviteContextProvider = ({ children }) => {
  const [invites, setInvites] = useState([]);
  const [invite, setInvite] = useState({});
  
  useEffect(() => {
    if (invite.id && invites.filter((each) => each.id === invite.id).length) {
      const selectedRec = invites.filter((each) => each.id === invite.id)
      setInvite({...selectedRec[0]})
    }
  }, [invites])

  useEffect(() => {
    const unsub = getInvitesInRealTime((data) => {
      setInvites(data)
    });
    return () => unsub?.();
  }, []);

  
  const contextValue = useMemo(() => ({
    invites,
    invite,
    setInvite,
  }), [invites, invite]);

  return (
    <InviteContext.Provider value={contextValue}>
      {children}
    </InviteContext.Provider>
  );
};
